import axios from "axios";
import API_CONFIG from "./ApiConfig";

// Use centralized API configuration
const BASE_URL = API_CONFIG.API_V1 + "/";
export const privateRequest = axios.create({
baseURL: BASE_URL,
});
export const Image_URL = API_CONFIG.IMAGE_URL;
privateRequest.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    // Only add authorization header if token exists and is not empty
    if (token && token.trim() !== "") {
      config.headers["authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors (unauthorized)
privateRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear storage and redirect to login
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default privateRequest;
